import { PrismAsyncLight as SyntaxHighlighter } from 'react-syntax-highlighter';

export default SyntaxHighlighter;
